import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import VueI18n from "vue-i18n";
import "./plugins/vuetify";
import router from "./router";
import "./registerServiceWorker";
import Vuex from "vuex";
import VueAxios from "vue-axios";
import axios from "axios";
import vuetify from "./plugins/vuetify";

import App from "./components/App.vue";
import storePlugin from "./store/storePlugin.js";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@mdi/font/css/materialdesignicons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import FlagIcon from "vue-flag-icon";
import VueClipboard from "vue-clipboard2";
import { backEndApiAddress } from "./config";
// Vue.config.productionTip = false

Vue.use(Vuex);

Vue.use(VueI18n);
Vue.use(VueClipboard);
Vue.use(require("vue-moment"));

const messages = {
  pl: require("./lang/pl.json"),
  en: require("./lang/en.json")
};

let currentLanguage = localStorage.getItem("language");
if (currentLanguage == null) currentLanguage = "pl";

export const i18n = new VueI18n({ locale: currentLanguage, messages });

// Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(storePlugin);
Vue.use(FlagIcon);

const token = localStorage.getItem("user-token");
axios.defaults.headers.common["Authorization"] = token;
axios.defaults.baseURL = backEndApiAddress;

const vue = new Vue({
  router,
  vuetify,
  data() {
    return {};
  },
  i18n,
  components: {
    App
  },
  render: h => h(App),
  created() {
    const self = this;
    axios.interceptors.request.use(
      function(config) {
        self.$store.dispatch("Ajax/RAISE_PENDING_CALLS");
        // show loader
        return config;
      },
      function(error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function(response) {
        self.$store.dispatch("Ajax/LOWER_PENDING_CALLS");
        if (typeof response.data.messages !== "undefined") {
          for (let message of response.data.messages) {
            message.text = i18n.t("$objectTranslator." + message.text.replace(/[."\s]/g, ""));
            self.$store.dispatch("snackbarPush", message);
          }
          return response.data;
        }
        return response;
      },
      function(error) {
        self.$store.dispatch("Ajax/LOWER_PENDING_CALLS");
        if (error.message === "Network Error") {
          self.$store.dispatch("snackbarPush", {
            text: i18n.t("global.networkError"),
            position: "down",
            color: "red"
          });
        } else if (typeof error.response !== "undefined" && typeof error.response.data.messages !== "undefined") {
          for (let message of error.response.data.messages) {
            message.text = i18n.t("$objectTranslator." + message.text.replace(/[."\s]/g, ""));
            self.$store.dispatch("snackbarPush", message);
          }
          return error.response.data;
        }
        return Promise.reject(error);
      }
    );
  }
}).$mount("#app");
export default vue;
